
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 2524.2 2524.2","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1049 12.1H12.1V1049H1049V12.1zM835.8 835.8H225.3V225.2h610.6v610.6zM12.1 2512.1H1049V1475.2H12.1v1036.9zm213.2-823.7h610.6V2299H225.3v-610.6zM1475.3 12.1V1049h1036.8V12.1H1475.3zM2299 835.8h-610.6V225.2H2299v610.6z"}}),_c('path',{attrs:{"d":"M350.7 1813.9h359.6v359.6H350.7zM350.7 350.6h359.6v359.7H350.7zM1813.8 350.6h359.8v359.7h-359.8zM12.1 1155.4h228.8v213.2H12.1zM1813.8 1581.8H2055v-213.2h244v213.2h213.1v-426.4h-698.3zM1686.2 1581.8v-426.4h-1270v213.2h930v213.2zM2299 2298.9h-97.7v-561.1h-213.1v182.6h-302v-213.2h-479.5v213.2h309.5v213.2h-170v378.5h340v-378.5h302v165.3H1885v213.2h627.1v-774.3H2299zM1155.6 12.1h213.2v518.4h-213.2zM1155.6 770.2h213.2V1049h-213.2z"}})])
          )
        }
      }
    